<template>
  <div class="select-1">
    <div class="banner">
      <img src="../images/banner_1.8e9061a1.jpg" alt="">
    </div>
  </div>
</template>

<script>
  import {
    slideTo
  } from '../../utils';
  export default {
    name: "selectOne",
    components: {},
    data() {
      return {

      }
    },
    methods: {

    },
    mounted() {}
  };
</script>

<style lang="scss" scoped>
  .select-1 {
    width: 100%;
    height: 100%;

    .banner {
      position: relative;
      width: 100%;
      height: 572px;
      text-align: center;
      background: RGBA(0, 28, 111, 1);
      img {
        width: 1300px;
        height: 572px;
        margin: 0 auto;
      }
    }
  }
</style>